import React from "react";
import { FunctionField } from "react-admin";
import { settings } from "../../../../app";
import { Typography } from "@mui/material";

const CustomImage = ({ label, style }) => {
  return (
    <FunctionField
      render={record => (
        <>
          <Typography sx={{ marginBottom: "1rem", color: "rgba(0, 0, 0, 0.6)", fontSize: "0.83em" }}>
            {label ? label : "Снимка"}
          </Typography>
          {record.file_url ? (
            <img
              alt=""
              src={`${settings.files_url}${record.file_url}`}
              style={style}
            />
          ) : (
            <Typography
              sx={{
                color: "rgba(0, 0, 0, 0.87)",
                fontSize: "0.875rem",
                fontWeight: "400",
                fontFamily: '"Roboto","Helvetica","Arial",sans-serif"',
              }}
            >
              {"Няма качена снимка"}
            </Typography>
          )}
        </>
      )}
    />
  );
};

export default CustomImage;
